import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
    Box,
    Typography,
    TextField,
    Button,
    Grid,
    Paper,
    CircularProgress
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import api from '../../../services/api';
import NavegadorGestao from "../../../components/NavBarGestao";

export default function EditarModulo() {
    const { tipo, id } = useParams();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [dados, setDados] = useState({
        codigo: '',
        marca: '',
        modelo: '',
        data_fabricacao: ''
    });

    useEffect(() => {
        async function buscarModulo() {
            try {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };

                let endpoint = '';
                if (tipo === 'ModuloPGM') endpoint = `v1/protected/modulopgm/listarporid/${id}`;
                else if (tipo === 'ModuloGatewaySentinel') endpoint = `v1/protected/modulogateway/listarporid/${id}`;
                else if (tipo === 'ModuloSentinel') endpoint = `v1/protected/modulos/sentinel/listarporid/${id}`;
                else if (tipo === 'ModuloSonoro') endpoint = `v1/protected/modulosonoro/listarporid/${id}`;

                if (endpoint) {
                    const response = await api.get(endpoint, { headers });
                    setDados(response.data);
                }
            } catch (_err) {
                console.error("Erro ao buscar módulo:", _err);
                alert("Erro ao carregar dados do módulo.");
            } finally {
                setLoading(false);
            }
        }
        buscarModulo();
    }, [tipo, id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDados(prev => ({ ...prev, [name]: value }));
    };

    const handleSalvar = async () => {
        setSaving(true);
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            let endpoint = '';
            if (tipo === 'ModuloPGM') endpoint = `v1/protected/modulopgm/atualizar/${id}`;
            else if (tipo === 'ModuloGatewaySentinel') endpoint = `v1/protected/modulogateway/atualizar/${id}`;
            else if (tipo === 'ModuloSentinel') endpoint = `v1/protected/modulos/sentinel/atualizar/${id}`;
            else if (tipo === 'ModuloSonoro') endpoint = `v1/protected/modulosonoro/atualizar/${id}`;

            if (endpoint) {
                await api.put(endpoint, dados, { headers });
                alert("Módulo atualizado com sucesso!");
                window.location.href = "/tecnica/modulos";
            }
        } catch (_err) {
            console.error("Erro ao atualizar módulo:", _err);
            alert("Erro ao salvar alterações.");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <NavegadorGestao
                AreaTecnica={true}
                Modulos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

            <Box p={3}>
                <Box display="flex" alignItems="center" mb={3}>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => window.location.href = "/tecnica/modulos"}
                        sx={{ mr: 2 }}
                    >
                        Voltar
                    </Button>
                    <Typography variant="h5" fontWeight="bold">
                        Editar Módulo: {tipo} (ID: {id})
                    </Typography>
                </Box>

                <Paper sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Código"
                                name="codigo"
                                value={dados.codigo || ''}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Marca"
                                name="marca"
                                value={dados.marca || ''}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Modelo"
                                name="modelo"
                                value={dados.modelo || ''}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Data de Fabricação"
                                name="data_fabricacao"
                                value={dados.data_fabricacao || ''}
                                onChange={handleChange}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                                onClick={handleSalvar}
                                disabled={saving}
                                size="large"
                            >
                                {saving ? 'Salvando...' : 'Salvar Alterações'}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </div>
    );
}
